/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Drawer, Card, Form, Row, Col, Select, Checkbox } from 'antd';
import { getOTACodes } from '@services/common'
import Input from '@ui/Input'
import TextArea from '@ui/TextArea'
import ActionButtonsBar from '@ui/ActionButtonsBar'
import './styles.scss'
import { getGuestrooms, getAmenitiesForAllGuestRooms, upsertAmenitiesForGuestRooms } from '../Amenities/helpers'
import { validateFormHelper } from '../Amenities/helpers'
import redirectImg from 'Styles/assets/redirect.png'

const CreateAmenity = (props: any) => {
  const [form] = Form.useForm()
  const [requiredFlag] = useState(true)
  const [miscValue, setMiscValue] = useState<string>('')
  const [typeOptionsValues, setTypesOptionsValues] = useState([])
  const [currencyValues, setCurrencyValues] = useState([])
  const [showField, setShowField] = useState(false)
  const [ready, setReady] = useState(false)
  const [data, setData] = useState([])
  const [dataAllGuestRooms, setDataAllGuestRooms] = useState([])
  const [disableFlag, setDisableFlag] = useState<boolean>(true)
  const [amenityName, setAmenityName] = useState<string>('')
  const [disabledSave, setdisabledSave] = useState<boolean>(false)

  const miscOptions = ['Amenity', 'Accessibility', 'Security']
  const unitOptions = [
    'Meters',
    'Millimeters',
    'Centimeters',
    'Yards',
    'Feet',
    'Inches',
    'Pixels',
  ]
  const Option = Select.Option

  const changeAmenities = (miscValue:string,isAmenitieChanging:boolean) => {
    setMiscValue(miscValue)
    getTypesValues(miscValue,isAmenitieChanging)
  }

  const getTypesValues = useCallback(
    async (miscValue: string | null | undefined,isAmenitieChanging:boolean) => {
      let res = undefined
      getCurrencyData()
      switch (miscValue) {
        case 'Amenity':
          res = await getOTACodes('RMA', '')
          console.log(res)
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Accessibility':
          res = await getOTACodes('PHY', '')
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Security':
          res = await getOTACodes('SEC', '')
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Feature':
          setShowField(false)
          break;
        default:
          return setTypesOptionsValues([])
      }
      if(isAmenitieChanging) form.setFieldsValue({ type: null })

    },
    [form],
  )

  const changeAmenityName = async (name: string) => {
    setReady(false)
    setAmenityName(name)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      data[index].checked = false
      // @ts-expect-error
      data[index].initial = false
      return amenities.map((amenitie : { type: string }) => {
        if (name.toLocaleLowerCase() === amenitie.type.toLocaleLowerCase()) {
          // @ts-expect-error
          data[index].checked = true
          // @ts-expect-error
          data[index].initial = true
        }
        return setData(data)
      })
    })

    setTimeout(() => setReady(true))
  }

  const onSelectAll = () => {
    setReady(false)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      return data[index].checked = true
    })
    validateForm()
    setTimeout(() => setReady(true))
  }

  const onSingleSelection = useCallback((e: any, idx: number) => {
    e.preventDefault()
    setReady(false)
    // @ts-expect-error
    data[idx].checked = e.target.checked

    setTimeout(() => setReady(true))
  }, [data])


  const onSave = async () => {
    const editBody: {}[] = []
    const values = form.getFieldsValue()
    const tempData: any[] = []

    setdisabledSave(true)

    // for existing amenities
    data.map((groom: any) => 
      groom.amenities.map((amenitie: any) => {
        if (amenitie.type === values.amenity) {
          tempData.push(groom?.grid)
          return editBody.push({
            idAmenity: amenitie?.amenityid,
            idAmenityLang: amenitie?.amenitylangid,
            idGuestRoom: groom?.grid,
            guestroom: groom?.id,
            selected: groom?.checked
          })
        } 
        return false
      })
    )

    // for new amenities
    data.map(({ grid, checked, id } : { grid: number, checked: boolean, id: string }) => {
      if (!tempData.includes(grid)) {
        return editBody.push({
          idAmenity: null,
          idAmenityLang: null,
          idGuestRoom: grid,
          guestroom: id,
          selected: checked
        })
      }
      return false
    })

    const body = {
      type: values.categorytype,
      amenityType: values.amenity,
      includedInRates: values.includedinrate,
      details: values.details, 
      amenityID: values.id,
      unitOfMeasure: values.unitofmeasure,
      currency: values.currency,
      chargeAmount: values.chargeamount,
      guestrooms: editBody
    }

    await upsertAmenitiesForGuestRooms(body)
    props.onClose()
    form.resetFields()  
    setTypesOptionsValues([])
    setDisableFlag(true)
    setReady(false)
    props.reload()
  }

  const getGuestRoomsData = useCallback(async () => {
    const { property: { guestrooms: { guestroom }}} = await getGuestrooms()
    const { guestRoomAmenitiesForAllRooms } = await getAmenitiesForAllGuestRooms()
    setData(guestroom)
    setDataAllGuestRooms(guestRoomAmenitiesForAllRooms)
    setdisabledSave(false)
  }, [])

  const getCurrencyData = useCallback(async () => {
    let res = await getOTACodes('CUR', '')
    setCurrencyValues(res.otacodes)
  }, [])

  const RoomTypes = useMemo(() => {
    return ready && data.map(({ name, id, checked, initial }, idx) => (
      <Col span={8} style={{ marginBottom: 24 }}>
        <Checkbox key={idx} onChange={(e: any) => {onSingleSelection(e, idx); validateForm();}} defaultChecked={checked}>
          <div style={{ position: 'absolute', top: -6, pointerEvents: 'none'}}>
            <span style={{ color: '#2D2D2D' }}>{name}</span>
            <br/>
            <span style={{ color: '#8E8E8E' }}>{id}</span>
          </div>
        </Checkbox>
        <img
          onClick={() => {
            props.setOperation('view')
            props.setCurrentRow(data[idx])
            props.setDefKey('7')
            props.setSingleAmenity(amenityName)
          }}
          src={redirectImg}
          alt='redirect to amenities'
          style={{
            marginLeft: 16,
            zIndex: 20,
            position: 'relative',
            top: -8,
            left: 46,
            cursor: 'pointer',
            display: checked && initial ? 'block' : 'none'
          }}/>
      </Col>
    ))
  }, [amenityName, data, onSingleSelection, props, ready])

  // validating the required values have been fufilled properly
  const validateForm = useCallback(() => {
    const selected: any[] = data.filter(({ checked }) => checked)
    if (data.length > 0 && selected.length > 0) {
      return validateFormHelper(form, setDisableFlag)
    } else {
      setDisableFlag(true)
    }
  }, [data, form])

  useEffect(() => {
    props.visible && getGuestRoomsData()
    if (!props.visible) {
      form.resetFields()  
      setTypesOptionsValues([])
      setDisableFlag(true)
      setReady(false)
    }
    getCurrencyData()
  }, [form, getCurrencyData, getGuestRoomsData, props.visible])


  return (
    <Drawer title="Create Amenity" placement="right" onClose={props.onClose} visible={props.visible} width={976}>
      <Card style={{ marginTop: -15, marginBottom: 65 }}> 
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{}}
          onValuesChange={validateForm}
          >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label='Amenity / Accessibility / Security'
                name='categorytype'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch onChange={(e: string) => changeAmenities(e,true)} placeholder='Please select'>
                  {miscOptions.map((item: string, i: number) => (
                    <Option key={`${item}-${i}`} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Amenity'
                name='amenity'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch onChange={(e: string) => changeAmenityName(e)}>
                {typeOptionsValues.map(
                  (item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ),
                )}
              </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Included in Rate'
                name='includedinrate'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch placeholder='Please select'>
                  <Option key={'yes-1'} value='Yes'>
                    Yes
                  </Option>
                  <Option key={'no-1'} value='No'>
                    No
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Amenity Detail'
                name='details'
                /* extra={
                  isonEdit ? (
                    <span className="blue-font">
                      Lanyon Maximum length:50. Please input exact time (24 hour
                      clock, - ex: 00:00-06:00 ) in Type Detail if choosing Type
                      as “If no 24 hour security, what are the hours?” for
                      Security. Please input minutes in Type Detail if choosing
                      Type as “Emergency svc response time (minutes).
                    </span>
                  ) : null
                } */
                rules={[
                  {
                    max: 50,
                    message: 'You have reached the max character length of 50',
                  },
                  // { required: true, message: 'This field is required' },
                ]}>
                <Input maxLength={50} placeholder='Detail'/>
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label='Amenity ID'
                name='id'>
                <Input placeholder='ID'/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Quantity'
                name='quantity'
                tooltip={{
                  title: 'Please provide quantity of the amenities depending on its room type',
                  placement: 'bottomLeft'
                }}
                rules={[
                  {
                    pattern: /^\+?\d+$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input disabled={true} placeholder='Number'/>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='Unit of Measure' name='unitofmeasure'>
                <Select allowClear showSearch placeholder='Please select'>
                  {unitOptions.map((item: string, i: number) => (
                    <Option key={`${item}-${i}`} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label='Currency' name='currency'>
                <Select allowClear showSearch placeholder='Please select'>
                  {currencyValues.map((item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Charge Amount'
                name='chargeamount'
                rules={[
                  {
                    pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input placeholder='Number'/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label='Description'
                name='description'
                tooltip={{
                  title: 'Please provide quantity of the amenities depending on its room type',
                  placement: 'bottomLeft'
                }}
                rules={[
                  {
                    max: 500,
                    message: 'You have reached the max character length of 500',
                  },
                ]}>
                <TextArea maxLength={500} rows={3} className='disabled' disabled={true} placeholder='Provide description here...'/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            {ready && data.length > 0 &&
            <Col span={24} style={{ marginBottom: 26 }}>
              <span style={{ color: '#999999' }}> Room included </span>
              <b style={{ color: '#06789D', cursor: 'pointer', marginLeft: 16}} onClick={onSelectAll}>Select All</b>
            </Col>}
            { ready && data.length > 0 && RoomTypes }
            { ready && data.length <= 0 &&
              <Col span={24} style={{ marginBottom: 26 }}>
                <p className='warning-text'>At least one room type must be completed and saved before amenities can be added</p>
              </Col>
            }
          </Row>
        </Form>
        <ActionButtonsBar
          onCancel={props.onClose}
          onSave={onSave}
          show={true}
          disabledSave={disabledSave}
        />
      </Card>
    </Drawer>
  )
}

export default CreateAmenity
